import {
    request,
} from '../request.js'

// 菜单列表
export function menuList(data) {
    return request({
        url: '/web/back/sysMenu/list',
        method: 'post',
        data
    })
}

//添加
export function addMenu(data) {
    return request({
        url: '/web/back/sysMenu/insert',
        method: 'post',
        data
    })
}

// 修改
export function editMenu(data) {
    return request({
        url: '/web/back/sysMenu/update',
        method: 'post',
        data
    })
}

// 删除
export function delMenu(data) {
    return request({
        url: '/web/back/sysMenu/delete' + "?id=" + data,
        method: 'delete',
    })
}

// 批量删除
export function allDelMenu(data) {
    return request({
        url: '/web/back/sysMenu/batch/delete',
        method: 'delete',
        data
    })
}